<template>

    <div class="modal__overlay">

        <div class="modal-config-portada">

            <h3>{{ $t('portada.MODULE_CONFIGURATION') }}</h3>

            <div class="use-portada">
                <h4>{{ $t('portada.MODULE_COVER') }}</h4>

                <div
                    :class="{ active: usePortada }"
                    class="toggle-button"
                    @click="status !== 'A1' && (usePortada = !usePortada)"
                    :style="{ opacity: status === 'A1' ? 0.5 : 1, cursor: status === 'A1' ? 'not-allowed' : 'pointer' }"
                >
                    <div class="toggle-handle"></div>
                </div>

            </div>

<!--             <template v-if="usePortada">
                <div @change="uploadFile($event)" class="upload-file__container" v-if="!imgUrl">
                    <label for="upload-file">Subir archivo<i class="material-icons">file_upload</i></label>
                    <input type="file" id="upload-file">
                </div>

                <div v-if="imgUrl" class="file-preview">
                    <img :src="imgUrl">
                </div>
            </template>
 -->
            <UploadFileDrag v-if="usePortada"
                containerCDN="content"
                @fileUploaded="fileCDN => imgUrl = fileCDN"
                @fileDeleted="imgUrl = ''"
            >
                <span>{{ $t('portada.DIMENSIONS_HINT') }}</span>
            </UploadFileDrag>

            <div class="modal__buttons">
                <button class="cancel" @click.stop="emit('close')">{{ $t('global.CANCEL') }}</button>
                <button class="confirm" @click.stop="save()" :disabled="saving || (usePortada && !imgUrl) || (!props.hasPortada && !usePortada)">
                    {{ $t('global.SAVE') }}<i class="material-icons">arrow_forward</i>
                </button>
            </div>

        </div>

    </div>

</template>

<script setup>
import { ref, defineProps, defineEmits, onMounted } from "vue";
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
//import storage from "@/plugins/azure-storage";
import UploadFileDrag from '@/components/UploadFileDrag.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const store = useStore();
const route = useRoute();

const props = defineProps({
    hasPortada: Boolean,
    contentId: String,
    status: String
})
const emit = defineEmits(['reload','close']);

const usePortada = ref();
const imgUrl = ref('');
const saving = ref(false);

const portadaModel = ref({
    id: props.contentId || null,
    moduleCfgId: route.params.moduleId,
    type: 'HTML',
    htmlType: 'PORTADA',
    orderNumber: 1,
    isMandatory: true,
    data: {
        Data: '',
    },
    courseCfgId: route.params.courseCfgId
})

const save = async ()=> { 
    saving.value = true;
    try {
        if(usePortada.value){
            portadaModel.value.data.Data = `<div class="imgHeader"><img src="${imgUrl.value}"/></div>`;
            props.hasPortada
                ? await store.dispatch('contentEditor_editContent', portadaModel.value)
                : ( console.log(portadaModel.value), await store.dispatch('contentEditor_createContent', portadaModel.value) );
        } else {
            await store.dispatch('contentEditor_removeContent', {contentId: props.contentId, courseCfgId: route.params.courseCfgId});
        }
        emit('reload');        
    } catch (error) {
        console.log(error);
        store.dispatch('notifications_create', { text: t('portada.ERROR_CONFIGURING_COVER') });
    } finally {
        saving.value = false;
    }
}

//const uploaded = ref(false);

/* async function uploadFile(event) {
    uploaded.value = false;
    let file = event.target.files[0];
    console.log(file.name)
    let fileCDN = await storage.updateFile(file,'content');
    imgUrl.value = `https://lmsforgestorage.blob.core.windows.net/contentresources/${fileCDN}`;
    uploaded.value = true;

}
 */
onMounted(async()=>{
    usePortada.value = props.hasPortada;
}) 


</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';
@import './commonStyles.scss';


.modal-config-portada{
    @include componentModal;
    max-width: 540px;
    display: flex;
    flex-direction: column;
    gap: 26px;
    .use-portada{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .file-preview{
        width: 100%;
        img{
            width: 100%;
            height: auto;
            object-fit: contain;
        }
    }
}

.upload-file__container{
    display: inline-block;
    position: relative;
    left: 0;
    text-align: center;
    #upload-file{
        visibility: hidden;
        position: absolute;
        width: 0px;
        height: 0px;
        top: 0;
        left: 0;
    }
    label,span{
        height: 36px;
        width: 181px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        border: 1px solid $green;
        background: #fff;
        border-radius: 44px;
        color: $green;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        .material-icons{
            color: $green;
            font-size: 19px;
        }
    }
}



</style>